var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.elementDef.CSSClass,attrs:{"href":"#"},on:{"click":function($event){return _vm._click($event)}}},[_vm._v(_vm._s(_vm.t(this.elementDef.Label)))])}
var staticRenderFns = []

export { render, staticRenderFns }